/***公用题型***/
export const TYPE_SHOW_FILLIN_CHINESE = '29'; // 中文填空题
export const TYPE_SHOW_FILLIN = '20';//填空
export const TYPE_SHOW_SELECT = '21';//选择
export const TYPE_SHOW_BANKEDCLOZE = '22';//选词填空
export const TYPE_SHOW_MAKESENTENCES = '23';//连词成句
export const TYPE_SHOW_DECLAIM = '24';//朗读
export const TYPE_SHOW_JUDGE = '25';//判断
export const TYPE_SHOW_RECITE = '26';//背诵
export const TYPE_SHOW_MULTISELECT = '27';//多选
export const TYPE_SHOW_LIGATURE = '31';//连线题
export const TYPE_SHOW_CLASSIFY = '32';//分类
export const TYPE_SHOW_SORT = '36';//排序
export const TYPE_SHOW_SORT_HEAR = '45';//
export const TYPE_SHOW_DECLAIM_RECITE = '55';
export const TYPE_SHOW_SUBJECTIVITY = '75';//主观题
export const TYPE_SHOW_COMPOSITION = '109';//作文题
export const TYPE_SHOW_SPOKEN_PHONETIC = '110'; // 口语音标题
export const TYPE_SHOW_SPOKENWORDS = '111';//口语单词
export const TYPE_SHOW_SPOKENPHRASE = '112';//口语短句
export const TYPE_SHOW_SPOKENSENTENCE = '113';//口语句子
export const TYPE_SHOW_SPOKENPASSAGE = '114';//口语段落
export const TYPE_SHOW_SEMIOPEN = '116'; // 半开放题
export const TYPE_SHOW_SPOKENPHRASE_CN = '117'; // 语文口语短语题
export const TYPE_SHOW_SPOKENSENTENCE_CN = '118'; // 语文口语句子
export const TYPE_SHOW_SPOKENPASSAGE_CN = '120'; // 语文口语段落题
export const TYPE_SHOW_CLUE = '148'; // 线索题
export const TYPE_SHOW_WRITING = '157'; // 写字题


export const TYPE_SHOW_SPOKEN_PINYIN = '99'; // 口语拼音
export const TYPE_SHOW_VIDEO = '65';//视频题
export const TYPE_SHOW_VIDEO_SUB = '66';//视频题子题
export const TYPE_SHOW_NL_ORDER = '71';//自然听音排序
export const TYPE_SHOW_NL_SELECT = '73';//自然听音选择
export const TYPE_JUDGE_READING = '76';//分级阅读评测
export const TYPE_JUDGE_SELETE = '77';//语文判分选择
export const TYPE_SHOW_SENTENCECLOZE = '81';//选句填空
// modify by yangzc for program question 2023/9/6
export const TYPE_SHOW_PROGRAM = '1024';//编程题
// add by john for scratchjr 2024/4/10
export const TYPE_SHOW_SCRATCHJR = '1025';//ScratchJr 1 - 2年级用
export const TYPE_SHOW_WRITINGCLASS = '1026';// 写字课题型
export const TYPE_SHOW_SCRATCH = '2001';//Scratch 4 - 6年级用
 
/***数学***/
export const TYPE_SHOW_HOLLOW = '28';//图片挖空
export const TYPE_SHOW_WORDPROBLEM = '30';//应用题
export const TYPE_SHOW_24POINTS = '52';//24点
export const TYPE_SHOW_VERTICAL = '35';//竖式
export const TYPE_SHOW_DELIVERY = '49';//脱式
export const TYPE_SHOW_SUDOKU = '51';//数独
export const TYPE_DELIVERY_SECOND = '90';//脱式二期
export const TYPE_VERTICAL_SECOND = '89';//竖式二期
export const TYPE_SHOW_SOLVINGPROBLEM = '137';//解答题

/****英语****/
export const TYPE_SHOW_SELECT_HEAR = '44';//听音选择
export const TYPE_SHOW_JUDGE_HEAR = '47';//听音判断
export const TYPE_SHOW_LIGATURE_HEAR = '46';//听音连线
export const TYPE_SHOW_EN_READ = '50';//英语阅读
export const TYPE_SHOW_EN_READ_HEAR = '37';
export const TYPE_SHOW_NEW_FOLLOW = '38';//英语跟读
export const TYPE_SHOW_NEW_READ_ALOUD = '39';//英语朗读
export const TYPE_SHOW_NEW_RECITE = '40';//英语背诵
export const TYPE_SHOW_NATURE_FOLLOW = '70'; // 自然跟读题
export const TYPE_SHOW_NATURE_IMG = '72'; // 自然看单词图片题
export const TYPE_WORD_READING = '57'; // 单词朗读
export const TYPE_SENTENCE_FOLLOW = '58'; // 句子跟读
export const TYPE_ESSAY_READING = '59'; // 短文朗读
export const TYPE_SITUATIONAL_DIALOGUE = '60'; // 情景问答

/***语文***/
export const TYPE_SHOW_SELECT_PINYIN = '83';//拼音选择
export const TYPE_SHOW_BANKEDCLOZE_PINYIN = '84';//带拼音选词填空
export const TYPE_SHOW_CN_READ = '56';//语文阅读
// v_7.8
export const TYPE_SHOW_LIGATURE_PINYIN = '91'; // 带拼音连线题
export const TYPE_SHOW_CLASSIFY_PINYIN = '92'; // 带拼音分类题
export const TYPE_SHOW_SORT_PINYIN = '93'; // 带拼音句子排序
export const TYPE_SHOW_MAKESENTENCES_PINYIN = '94'; // 带拼音连词成句
export const TYPE_SHOW_JUDGE_PINYIN = '95';// 带拼音判断题

/****AI直播****/
export const TYPE_SHOW_NEW_AISUDUKU = '78';//ai数独题
export const TYPE_SHOW_NEW_AISUDUKU_PARENT = '79';//ai数独题父题
export const TYPE_SHOW_NEW_AISUDUKU_SHIP = '533';//ai战舰数独
export const TYPE_SHOW_FILLINBLANK = '80';//材料填空

export const TYPE_SHOW_ENUMERATION = '520';//AI枚举题
export const TYPE_SHOW_NUM_MATRIX = '521';//AI数阵题
export const TYPE_SHOW_EQUATION = '522';//AI算式题
export const TYPE_SHOW_AIEN_WORD_READING = '523'; //AI单词朗读
export const TYPE_SHOW_AIEN_SENTENCE_READING = '524'; //AI句子朗读

export const TYPE_SHOW_AI_FIX_DRAG_FILLIN= '525'; //定点拖拽填空
export const TYPE_SHOW_AI_FIX_DRAG_SELECT= '526'; //定点拖拽选择
export const TYPE_SHOW_AI_CLEAN_FILLIN= '528'; //消除填空
export const TYPE_SHOW_AI_CLEAN_SELECT= '529'; //消除选择
export const TYPE_SHOW_AI_UNFIX_DRAG_FILLIN= '530'; //不定点拖拽填空
export const TYPE_SHOW_AI_UNFIX_DRAG_SELECT= '531'; //不定点拖拽选择
export const TYPE_SHOW_AI_READ_NUMBER= '532'; //读数题
//寒假
export const TYPE_SHOW_AI_WORD_SPELL='535';//单词拼写
export const TYPE_SHOW_AI_CONNECT_WORDS='534';//连词成句
export const TYPE_SHOW_AI_FIX_DRAG= '527'; //定点拖拽

//菁优网
export const TYPE_SHOW_FILLIN_2 = '100'//填空题2
export const TYPE_SHOW_SELECT_2 = '101'//选择题2
export const TYPE_SHOW_JUDGE_2 = '102'//判断题2
export const TYPE_SHOW_WORDPROBLEM_2 = '103'//应用题2
export const TYPE_SHOW_CAOZUO = '104'//操作题




/*************************************************/

export const TYPE_TO_NUM = {
    fillinchinese: TYPE_SHOW_FILLIN_CHINESE,
    fillin: TYPE_SHOW_FILLIN,
    select:TYPE_SHOW_SELECT,
    judge:TYPE_SHOW_JUDGE,
    hollow:TYPE_SHOW_HOLLOW,
    wordproblem:TYPE_SHOW_WORDPROBLEM,
    ligature:TYPE_SHOW_LIGATURE,
    classify:TYPE_SHOW_CLASSIFY,
    multiSelect:TYPE_SHOW_MULTISELECT,
    bankedcloze:TYPE_SHOW_BANKEDCLOZE,//选词填空
    makeSentences:TYPE_SHOW_MAKESENTENCES,//连词成句
    cnread:TYPE_SHOW_CN_READ,//阅读
    enread:TYPE_SHOW_EN_READ,//阅读
    declaim:TYPE_SHOW_DECLAIM,//朗读
    recite:TYPE_SHOW_RECITE,//背诵
    vertical:TYPE_SHOW_VERTICAL,
    sort:TYPE_SHOW_SORT,
    declaimrecite:TYPE_SHOW_DECLAIM_RECITE,
    delivery:TYPE_SHOW_DELIVERY,
    deliverySecond:TYPE_DELIVERY_SECOND,
    verticalSecond:TYPE_VERTICAL_SECOND,
    suduku:TYPE_SHOW_SUDOKU,
    point24:TYPE_SHOW_24POINTS,
    videodubbing: TYPE_SHOW_VIDEO,
    subjectivity:TYPE_SHOW_SUBJECTIVITY,
    composition:TYPE_SHOW_COMPOSITION,
    spokenWords:TYPE_SHOW_SPOKENWORDS,//口语单词
    spokenPhrase:TYPE_SHOW_SPOKENPHRASE,//口语短语
    spokenSentence:TYPE_SHOW_SPOKENSENTENCE,//口语句子
    spokenPassage:TYPE_SHOW_SPOKENPASSAGE,//口语段落
    spokenPhonetic:TYPE_SHOW_SPOKEN_PHONETIC,//口语音标
    semiOpen:TYPE_SHOW_SEMIOPEN,//半开放题
    spokenPinyin:TYPE_SHOW_SPOKEN_PINYIN,//口语拼音
    spokenPhraseCn:TYPE_SHOW_SPOKENPHRASE_CN,//语文口语短语题
    spokenSentenceCn:TYPE_SHOW_SPOKENSENTENCE_CN,//语文口语句子
    spokenPassageCn:TYPE_SHOW_SPOKENPASSAGE_CN,//语文口语段落题
    writing: TYPE_SHOW_WRITING, // 写字题
    clue: TYPE_SHOW_CLUE,
    newfollow:TYPE_SHOW_NEW_FOLLOW,//英语跟读
    newreadaloud:TYPE_SHOW_NEW_READ_ALOUD,//英语朗读
    newrecite:TYPE_SHOW_NEW_RECITE,//英语背诵
    // modify by yangzc for program question 2023/9/6
    program: TYPE_SHOW_PROGRAM, //编程题
    scratchJR: TYPE_SHOW_SCRATCHJR, //ScratchJr
    writingClass: TYPE_SHOW_WRITINGCLASS, // 写字课题型
    scratch: TYPE_SHOW_SCRATCH, //Scratch
    
    //6.16.0英语口语评测
    wordReading:TYPE_WORD_READING,//单词朗读
    sentenceFollow:TYPE_SENTENCE_FOLLOW,//句子跟读
    essayReading:TYPE_ESSAY_READING,//短文朗读
    situationalDialogue:TYPE_SITUATIONAL_DIALOGUE,//情景问答

    aisudoku:TYPE_SHOW_NEW_AISUDUKU,//ai数独
    aisudokuparent:TYPE_SHOW_NEW_AISUDUKU_PARENT,//ai数独
    aisudokuship:TYPE_SHOW_NEW_AISUDUKU_SHIP,//ai战舰数独
    fillinblank: TYPE_SHOW_FILLINBLANK, //材料填空
    sentencecloze: TYPE_SHOW_SENTENCECLOZE, //选句填空
    enumeration:TYPE_SHOW_ENUMERATION,//AI枚举题
    numMatrix:TYPE_SHOW_NUM_MATRIX,//AI数阵题

    naturefollow: TYPE_SHOW_NATURE_FOLLOW, // 自然跟读题
    natureimg: TYPE_SHOW_NATURE_IMG, // 自然看单词图片题

    nlorder: TYPE_SHOW_NL_ORDER, //自然听音排序
    nlselect: TYPE_SHOW_NL_SELECT, //自然听音选择

    judgeRead: TYPE_JUDGE_READING, // 分级阅读评测
    judgeSelect: TYPE_JUDGE_SELETE, // 语文判分选择s
    equation: TYPE_SHOW_EQUATION,// AI算式题
    aiEnReading:TYPE_SHOW_AIEN_WORD_READING,

    aiWordSpell:TYPE_SHOW_AI_WORD_SPELL,//单词拼写
    aiConnectWords:TYPE_SHOW_AI_CONNECT_WORDS,//连词成句
    aiFixDrag:TYPE_SHOW_AI_FIX_DRAG,//AI定点拖拽

    fillin2:TYPE_SHOW_FILLIN_2,//填空题2
    select2:TYPE_SHOW_SELECT_2,//选择题2
    judge2:TYPE_SHOW_JUDGE_2,//判断题2
    wordproblem2:TYPE_SHOW_WORDPROBLEM_2,//应用题2
    caozuo:TYPE_SHOW_CAOZUO,//操作题
    solvingproblem: TYPE_SHOW_SOLVINGPROBLEM, //解答题

};

export const NUM_TO_TYPE={
    [TYPE_SHOW_FILLIN_CHINESE]: 'fillinchinese',
    [TYPE_SHOW_FILLIN]: 'fillin',
    [TYPE_SHOW_SELECT]:'select',
    [TYPE_SHOW_SELECT_PINYIN]:'select',
    [TYPE_SHOW_BANKEDCLOZE_PINYIN]:'bankedcloze',
    [TYPE_SHOW_SELECT_HEAR]:'select',//听力
    [TYPE_SHOW_JUDGE]:'judge',
    [TYPE_SHOW_JUDGE_PINYIN]: 'judge', // 带拼音判断题(v_7.8)
    [TYPE_SHOW_JUDGE_HEAR]:'judge',//听力
    [TYPE_SHOW_HOLLOW]:'hollow',
    [TYPE_SHOW_WORDPROBLEM]:'wordproblem',
    [TYPE_SHOW_LIGATURE]:'ligature',
    [TYPE_SHOW_LIGATURE_PINYIN]: 'ligature', // 带拼音连线题(v_7.8)
    [TYPE_SHOW_LIGATURE_HEAR]:'ligature',//听力
    [TYPE_SHOW_CLASSIFY]:'classify',
    [TYPE_SHOW_CLASSIFY_PINYIN]: 'classify', // 带拼音分类题(v_7.8)
    [TYPE_SHOW_MULTISELECT]:'multiSelect',
    [TYPE_SHOW_BANKEDCLOZE]:'bankedcloze',
    [TYPE_SHOW_MAKESENTENCES]:'makeSentences',
    [TYPE_SHOW_MAKESENTENCES_PINYIN]: 'makeSentences', // 带拼音连词成句(v_7.8)
    [TYPE_SHOW_DECLAIM]:'declaim',//朗读
    // modify by yangzc for program question 2023/9/6
    [TYPE_SHOW_PROGRAM]:'program',//编程题
    [TYPE_SHOW_SCRATCHJR]: 'scratchJR',//ScratchJr
    [TYPE_SHOW_SCRATCH]:'scratch',//Scratch
    [TYPE_SHOW_WRITINGCLASS]: 'writingClass', // 写字课题型

    [TYPE_SHOW_RECITE]:'recite',
    [TYPE_SHOW_VERTICAL]:'vertical',

    [TYPE_SHOW_CN_READ]:'cnread',
    [TYPE_SHOW_EN_READ]:'enread',
    [TYPE_SHOW_EN_READ_HEAR]:'enread',
    [TYPE_SHOW_SORT]:'sort',
    [TYPE_SHOW_SORT_PINYIN]: 'sort', // 带拼音句子排序(v_7.8)
    [TYPE_SHOW_SORT_HEAR]:'sort',//听力
    [TYPE_SHOW_DECLAIM_RECITE]:'declaimrecite',
    [TYPE_SHOW_DELIVERY]:'delivery',
    [TYPE_DELIVERY_SECOND]:'deliverySecond',
    [TYPE_VERTICAL_SECOND]:'verticalSecond',
    [TYPE_SHOW_SUDOKU]:'suduku',
    [TYPE_SHOW_24POINTS]:'point24',

    [TYPE_SHOW_VIDEO] :'videodubbing',//视频题

    [TYPE_SHOW_SUBJECTIVITY]:'subjectivity',//主观题
    [TYPE_SHOW_COMPOSITION]:'composition',//作文题
    [TYPE_SHOW_SPOKENWORDS]: 'spokenWords',//口语单词
    [TYPE_SHOW_SPOKENPHRASE]:'spokenPhrase',//口语短语
    [TYPE_SHOW_SPOKENSENTENCE]:'spokenSentence',//口语句子
    [TYPE_SHOW_SPOKENPASSAGE]:'spokenPassage',//口语段落
    [TYPE_SHOW_SPOKEN_PHONETIC]:'spokenPhonetic',//口语音标
    [TYPE_SHOW_SEMIOPEN]:'semiOpen',//半开放题
    [TYPE_SHOW_SPOKEN_PINYIN]:'spokenPinyin',//口语拼音
    [TYPE_SHOW_SPOKENPHRASE_CN]:'spokenPhraseCn',//语文口语短语题
    [TYPE_SHOW_SPOKENSENTENCE_CN]:'spokenSentenceCn',//语文口语句子
    [TYPE_SHOW_SPOKENPASSAGE_CN]:'spokenPassageCn',//语文口语段落题
    [TYPE_SHOW_WRITING]:'writing',//写字题
    [TYPE_SHOW_NEW_FOLLOW]:'newfollow',//英语跟读
    [TYPE_SHOW_NEW_READ_ALOUD]:'newreadaloud',//英语朗读
    [TYPE_SHOW_NEW_RECITE]:'newrecite',//英语背诵
    [TYPE_SHOW_CLUE]:'clue',//线索题


    [TYPE_WORD_READING]:'wordReading',//单词朗读
    [TYPE_SENTENCE_FOLLOW]:'sentenceFollow',//句子跟读
    [TYPE_ESSAY_READING]:'essayReading',//短文朗读
    [TYPE_SITUATIONAL_DIALOGUE]:'situationalDialogue',//情景问答

    [TYPE_SHOW_ENUMERATION]:'enumeration',
    [TYPE_SHOW_NUM_MATRIX]:'numMatrix',
    [TYPE_SHOW_EQUATION]:'equation',//AI算式题
    [TYPE_SHOW_NEW_AISUDUKU]:'aisudoku',
    [TYPE_SHOW_NEW_AISUDUKU_PARENT]:'aisudokuparent',
    [TYPE_SHOW_NEW_AISUDUKU_SHIP]:'aisudokuship',
    [TYPE_SHOW_FILLINBLANK]: 'fillinblank', //材料填空
    [TYPE_SHOW_SENTENCECLOZE]: 'sentencecloze', //选句填空
    [TYPE_SHOW_NL_ORDER]:'nlorder',//自然听音选择
    [TYPE_SHOW_NL_SELECT]:'nlselect',//自然听音选择
    [TYPE_SHOW_NATURE_FOLLOW]: 'naturefollow', // 自然跟读题
    [TYPE_SHOW_NATURE_IMG]: 'natureimg', // 自然看单词图片题
    [TYPE_JUDGE_READING]: 'judgeRead', //分级阅读评测
    [TYPE_JUDGE_SELETE]: 'judgeSelect', //语文判分选择

    [TYPE_SHOW_AIEN_WORD_READING]:'aiEnReading',//AI朗读
    [TYPE_SHOW_AIEN_SENTENCE_READING]:'aiEnReading',


    [TYPE_SHOW_AI_FIX_DRAG_FILLIN]:'aiFixDragFillin',
    [TYPE_SHOW_AI_FIX_DRAG_SELECT]:'aiFixDragSelect',
    [TYPE_SHOW_AI_CLEAN_FILLIN]:'aiCleanFillin',
    [TYPE_SHOW_AI_CLEAN_SELECT]:'aiCleanSelect',
    [TYPE_SHOW_AI_UNFIX_DRAG_FILLIN]:'aiUnfixDragFillin',
    [TYPE_SHOW_AI_UNFIX_DRAG_SELECT]:'aiUnFixDragSelect',
    [TYPE_SHOW_AI_READ_NUMBER]:'aiReadNumber',

    [TYPE_SHOW_AI_WORD_SPELL]:'aiWordSpell',//单词拼写
    [TYPE_SHOW_AI_CONNECT_WORDS]:'aiConnectWords',//连词成句
    [TYPE_SHOW_AI_FIX_DRAG]:'aiFixDrag',//定点拖拽

    [TYPE_SHOW_FILLIN_2]:'fillin2',//填空题2
    [TYPE_SHOW_SELECT_2]:'select2',//选择题2
    [TYPE_SHOW_JUDGE_2]:'judge2',//判断题2
    [TYPE_SHOW_WORDPROBLEM_2]:'wordproblem2',//应用题2
    [TYPE_SHOW_CAOZUO]:'caozuo',//操作题
    [TYPE_SHOW_SOLVINGPROBLEM]:'solvingproblem',

}

export const TYPE_MAP = {
    [TYPE_SHOW_FILLIN_CHINESE]:'中文填空题',
    [TYPE_SHOW_FILLIN]:'填空题',
    [TYPE_SHOW_SELECT]:'选择题',
    [TYPE_SHOW_SELECT_PINYIN]:'带拼音选择题',
    [TYPE_SHOW_SELECT_HEAR]:'选择题',
    [TYPE_SHOW_JUDGE]:'判断题',
    [TYPE_SHOW_JUDGE_HEAR]:'判断题',
    [TYPE_SHOW_JUDGE_PINYIN]: '带拼音判断题',
    [TYPE_SHOW_HOLLOW]:'图片挖空',//无答案 无选项
    [TYPE_SHOW_MULTISELECT]:'多选题',
    [TYPE_SHOW_WORDPROBLEM]:'应用题',//新增应用题
    [TYPE_SHOW_LIGATURE]:'连线题',
    [TYPE_SHOW_LIGATURE_HEAR]:'连线题',
    [TYPE_SHOW_LIGATURE_PINYIN]: '带拼音连线题',
    [TYPE_SHOW_CLASSIFY]:'分类题',
    [TYPE_SHOW_CLASSIFY_PINYIN]: '带拼音分类题',
    [TYPE_SHOW_BANKEDCLOZE]:'选词填空',
    [TYPE_SHOW_BANKEDCLOZE_PINYIN]:'带拼音选词填空',
    [TYPE_SHOW_MAKESENTENCES]:'连词成句',
    [TYPE_SHOW_MAKESENTENCES_PINYIN]: '带拼音连词成句',
    [TYPE_SHOW_DECLAIM]:'朗读题',
    [TYPE_SHOW_RECITE]:'背诵题',
    [TYPE_SHOW_VERTICAL]:'竖式',
    // modify by yangzc for program question 2023/9/6
    [TYPE_SHOW_PROGRAM]: 'Python编程题', //编程题
    [TYPE_SHOW_SCRATCHJR]: 'Scratch JR编程题', //ScratchJr
    [TYPE_SHOW_SCRATCH]:'Scratch编程题',
    [TYPE_SHOW_WRITINGCLASS]: '写字课题型', // 写字课题型

    [TYPE_SHOW_CN_READ]:'语文阅读题',
    [TYPE_SHOW_EN_READ]:'英语阅读题',
    [TYPE_SHOW_EN_READ_HEAR]:'英语阅读题',

    [TYPE_SHOW_SORT]:'句子排序',
    [TYPE_SHOW_SORT_HEAR]:'句子排序',
    [TYPE_SHOW_SORT_PINYIN]: '带拼音句子排序',
    [TYPE_SHOW_DECLAIM_RECITE]:'朗读背诵题',
    [TYPE_SHOW_DELIVERY]:'脱式',
    [TYPE_DELIVERY_SECOND]:'脱式二期',
    [TYPE_VERTICAL_SECOND]:'竖式二期',
    [TYPE_SHOW_SUDOKU]:'数独',
    [TYPE_SHOW_24POINTS]: '24点题',

    [TYPE_SHOW_VIDEO] :'视频配音题',
    [TYPE_SHOW_VIDEO_SUB] :'视频配音子题',

    [TYPE_SHOW_SUBJECTIVITY]:'主观题',
    [TYPE_SHOW_COMPOSITION]:'作文题',
    [TYPE_SHOW_SPOKENWORDS]:'口语单词题',
    [TYPE_SHOW_SPOKENPHRASE]:'口语短语题',
    [TYPE_SHOW_SPOKENSENTENCE]:'口语句子题',
    [TYPE_SHOW_SPOKENPASSAGE]:'口语段落题',
    [TYPE_SHOW_SPOKEN_PHONETIC]:'口语音标题',
    [TYPE_SHOW_SEMIOPEN]:'半开放题',
    [TYPE_SHOW_SPOKEN_PINYIN]:'口语拼音',
    [TYPE_SHOW_SPOKENPHRASE_CN]:'口语短语',
    [TYPE_SHOW_SPOKENSENTENCE_CN]:'口语句子',
    [TYPE_SHOW_SPOKENPASSAGE_CN]:'口语段落',
    [TYPE_SHOW_WRITING]:'写字题',
    [TYPE_SHOW_CLUE]:'线索题',
    [TYPE_SHOW_NEW_FOLLOW]:'英语跟读',//英语跟读
    [TYPE_SHOW_NEW_READ_ALOUD]:'英语朗读',//英语朗读
    [TYPE_SHOW_NEW_RECITE]:'英语背诵',//英语背诵

    [TYPE_WORD_READING]:'单词朗读',//单词朗读
    [TYPE_SENTENCE_FOLLOW]:'句子跟读',//句子跟读
    [TYPE_ESSAY_READING]:'短文朗读',//短文朗读
    [TYPE_SITUATIONAL_DIALOGUE]:'情景问答',//情景问答

	[TYPE_SHOW_ENUMERATION]:'AI枚举题',
    [TYPE_SHOW_NUM_MATRIX]:'AI数阵题',
    [TYPE_SHOW_EQUATION]:'AI算式题',
    [TYPE_SHOW_NEW_AISUDUKU]:'AI数独题',
    [TYPE_SHOW_NEW_AISUDUKU_PARENT]:'AI多序列数独题',
    [TYPE_SHOW_NEW_AISUDUKU_SHIP]:'AI战舰数独题',
    [TYPE_SHOW_FILLINBLANK]: '材料填空', // 材料填空
    [TYPE_SHOW_SENTENCECLOZE]: '选句填空', //选句填空

    [TYPE_SHOW_NL_ORDER]:'自然听音排序',//自然听音排序
    [TYPE_SHOW_NL_SELECT]:'自然听音选择',//自然听音选择
    [TYPE_SHOW_NATURE_FOLLOW]: '自然跟读题', // 自然跟读题
    [TYPE_SHOW_NATURE_IMG]: '自然看单词图片题', // 自然看单词图片题
    [TYPE_JUDGE_READING]: '分级阅读评测', //分级阅读评测
    [TYPE_JUDGE_SELETE]: '判分选择题', //语文判分选择
    [TYPE_SHOW_EQUATION]: 'AI算式题', //AI算式题，
    [TYPE_SHOW_AIEN_WORD_READING]: 'AI朗读题', //AI朗读题
    [TYPE_SHOW_AIEN_SENTENCE_READING]: 'AI朗读题',
    [TYPE_SHOW_AI_FIX_DRAG_FILLIN]:'定点拖拽填空题',
    [TYPE_SHOW_AI_CLEAN_FILLIN]:'消除填空题',
    [TYPE_SHOW_AI_UNFIX_DRAG_FILLIN]:'不定点拖拽填空题',
    [TYPE_SHOW_AI_FIX_DRAG_SELECT]:'定点拖拽选择题',
    [TYPE_SHOW_AI_CLEAN_SELECT]:'消除选择题',
    [TYPE_SHOW_AI_UNFIX_DRAG_SELECT]:'不定点拖拽选择题',
    [TYPE_SHOW_AI_READ_NUMBER]:'读数题',
    //寒假
    [TYPE_SHOW_AI_WORD_SPELL]:'单词拼写',
    [TYPE_SHOW_AI_CONNECT_WORDS]:'连词成句',
    [TYPE_SHOW_AI_FIX_DRAG]:'定点拖拽题',

    //菁优网
    [TYPE_SHOW_FILLIN_2]:'填空题2',
    [TYPE_SHOW_SELECT_2]:'选择题2',
    [TYPE_SHOW_JUDGE_2]:'判断题2',
    [TYPE_SHOW_WORDPROBLEM_2]:'应用题2',
    [TYPE_SHOW_CAOZUO]:'操作题',
    [TYPE_SHOW_SOLVINGPROBLEM]:'解答题',
};
//阅读题子题使用
export const TYPE_MAP_PINYIN = {
    [TYPE_SHOW_FILLIN_CHINESE]:'中文填空题',
    [TYPE_SHOW_FILLIN]:'填空题',
    [TYPE_SHOW_SELECT]:'选择题',
    [TYPE_SHOW_SELECT_PINYIN]:'选择题',
    [TYPE_SHOW_SELECT_HEAR]:'选择题',
    [TYPE_SHOW_JUDGE]:'判断题',
    [TYPE_SHOW_JUDGE_HEAR]:'判断题',
    [TYPE_SHOW_JUDGE_PINYIN]: '判断题',
    [TYPE_SHOW_HOLLOW]:'图片挖空',//无答案 无选项
    [TYPE_SHOW_MULTISELECT]:'多选题',
    [TYPE_SHOW_WORDPROBLEM]:'应用题',//新增应用题
    [TYPE_SHOW_LIGATURE]:'连线题',
    [TYPE_SHOW_LIGATURE_HEAR]:'连线题',
    [TYPE_SHOW_LIGATURE_PINYIN]: '连线题',
    [TYPE_SHOW_CLASSIFY]:'分类题',
    [TYPE_SHOW_CLASSIFY_PINYIN]: '分类题',
    [TYPE_SHOW_BANKEDCLOZE]:'选词填空',
    [TYPE_SHOW_BANKEDCLOZE_PINYIN]:'选词填空',
    [TYPE_SHOW_MAKESENTENCES]:'连词成句',
    [TYPE_SHOW_MAKESENTENCES_PINYIN]: '连词成句',
    [TYPE_SHOW_DECLAIM]:'朗读题',
    [TYPE_SHOW_RECITE]:'背诵题',
    [TYPE_SHOW_VERTICAL]:'竖式',

    [TYPE_SHOW_CN_READ]:'语文阅读题',
    [TYPE_SHOW_EN_READ]:'英语阅读题',
    [TYPE_SHOW_EN_READ_HEAR]:'英语阅读题',

    [TYPE_SHOW_SORT]:'句子排序',
    [TYPE_SHOW_SORT_HEAR]:'句子排序',
    [TYPE_SHOW_SORT_PINYIN]: '句子排序',
    [TYPE_SHOW_DECLAIM_RECITE]:'朗读背诵题',
    [TYPE_SHOW_DELIVERY]:'脱式',
    [TYPE_DELIVERY_SECOND]:'脱式二期',
    [TYPE_VERTICAL_SECOND]:'竖式二期',
    [TYPE_SHOW_SUDOKU]:'数独',
    [TYPE_SHOW_24POINTS]: '24点题',

    [TYPE_SHOW_VIDEO] :'视频配音题',
    [TYPE_SHOW_VIDEO_SUB] :'视频配音子题',

    [TYPE_SHOW_SUBJECTIVITY]:'主观题',
    [TYPE_SHOW_COMPOSITION]:'作文题',
    [TYPE_SHOW_SPOKENWORDS]:'口语单词题',
    [TYPE_SHOW_SPOKENPHRASE]:'口语短语题',
    [TYPE_SHOW_SPOKENSENTENCE]:'口语句子题',
    [TYPE_SHOW_SPOKENPASSAGE]:'口语段落题',
    [TYPE_SHOW_SPOKEN_PHONETIC]:'口语音标题',
    [TYPE_SHOW_SPOKENPHRASE_CN]:'口语短语题',
    [TYPE_SHOW_SEMIOPEN]:'半开放题',
    [TYPE_SHOW_SPOKEN_PINYIN]:'口语拼音',
    [TYPE_SHOW_SPOKENSENTENCE_CN]:'口语句子',
    [TYPE_SHOW_SPOKENPASSAGE_CN]:'口语段落',
    [TYPE_SHOW_WRITING]:'写字题',
    [TYPE_SHOW_NEW_FOLLOW]:'英语跟读',//英语跟读
    [TYPE_SHOW_NEW_READ_ALOUD]:'英语朗读',//英语朗读
    [TYPE_SHOW_NEW_RECITE]:'英语背诵',//英语背诵
    [TYPE_SHOW_CLUE]:'线索题',

    [TYPE_WORD_READING]:'单词朗读',//单词朗读
    [TYPE_SENTENCE_FOLLOW]:'句子跟读',//句子跟读
    [TYPE_ESSAY_READING]:'短文朗读',//短文朗读
    [TYPE_SITUATIONAL_DIALOGUE]:'情景问答',//情景问答

	[TYPE_SHOW_ENUMERATION]:'AI枚举题',
    [TYPE_SHOW_NUM_MATRIX]:'AI数阵题',
    [TYPE_SHOW_EQUATION]:'AI算式题',
    [TYPE_SHOW_NEW_AISUDUKU]:'AI数独题',
    [TYPE_SHOW_NEW_AISUDUKU_PARENT]:'AI多序列数独题',
    [TYPE_SHOW_NEW_AISUDUKU_SHIP]:'AI战舰数独题',
    [TYPE_SHOW_FILLINBLANK]: '材料填空', // 材料填空
    [TYPE_SHOW_SENTENCECLOZE]: '选句填空', //选句填空

    [TYPE_SHOW_NL_ORDER]:'自然听音排序',//自然听音排序
    [TYPE_SHOW_NL_SELECT]:'自然听音选择',//自然听音选择
    [TYPE_SHOW_NATURE_FOLLOW]: '自然跟读题', // 自然跟读题
    [TYPE_SHOW_NATURE_IMG]: '自然看单词图片题', // 自然看单词图片题
    [TYPE_JUDGE_READING]: '分级阅读评测', //分级阅读评测
    [TYPE_JUDGE_SELETE]: '判分选择题', //语文判分选择
    [TYPE_SHOW_EQUATION]: 'AI算式题', //AI算式题
};

export const TYPE_MAP_VIEW = {
    '0':'全部',
    '-1':'默认',
    '1':'标准填空',
    '2':'口算',//无答案 无选项
    '3':'脱式计算',
    '4':'竖式计算',
    '5':'列式计算',
    '6':'操作题',
    '7':'解决问题',
    '8':'选择题',
    '9':'判断题',

    '200':'笔试填空题',
    '201':'笔试选择题',
    '202':'笔试选词填空',
    '205':'笔试判断题',
    '211':'笔试连线题',
    '216':'笔试排序题',
    '230':'笔试英语阅读理解',
    '223':'听力填空',
    '224':'听力选择',
    '228':'听力选词填空',
    '227':'听力判断',
    '226':'听力连线',
    '225':'听力排序',
    '217':'英语阅读理解',
    '231':'自然跟读题',
    '232':'自然听音排序题',
    '233':'发音排序',
    '234':'字母排序',
    '235':'单词二选一',
    '236':'单词图片四选二',
    '237':'单词三选一',
    '535': '单词拼写',
    '514':'连词成句',
    '527':'定点拖拽',
};
export const WELL_CHOSEN_MAP = {
    '11':'基础',
    '12':'进阶',
    '13':'课内',
    '14':'课外',

};
export const QUESTIONSTAGE = {"1": "阅读理解", "2": "推理分析", "3": "列式解答"}

export const AUTHORITY ={
    QUESTIONBOX_CHECK:11,//题盒子审题权限
    QUESTIONBOX_ENTRY : 12,//题盒子录题权限
    QUESTIONBOX_ENTRYGROUP_ADMIN : 13,//题盒子录题组管理
    QUESTIONBOX_TASK_ADMIN : 14,//题盒子任务管理
}




// WEBPACK FOOTER //
// ./src/utils/questionType.js